<script>
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

</script>

<style>
  input.fizz-input-search-subdued {
    background-image: none;
    margin-right: 0;
  }

  .search-button {
    position: absolute;
    right: 0.25rem;
    top: 0.25rem;
  }

</style>

<form>
  <div class="fizz-full-width">
    {#if $LayoutStore.isDesktop}
      <input
        on:click
        type="text"
        class="fizz-full-width unset-color fizz-input-large fizz-input-search-subdued"
        placeholder="Search products, categories, and brands"
      />

      <button on:click class="fizz-icon-button search-button fizz-text-brand">
        <Icon type="Search" height="18" width="18" className="fizz-text-brand" />
      </button>
      <!-- <SearchBar {Analytics} /> -->
    {:else}
      <input
        type="search"
        class="fizz-full-width fizz-input-search-subdued"
        style="padding-right: 0.5rem"
        data-testid="retailer_header_product_search_input"
        id="retailer_header_product_search_input"
        on:click
        placeholder="Search"
      />
      <button class="fizz-icon-button-small search-button fizz-text-brand" on:click>
        <Icon type="Search" height="16" width="16" className="fizz-text-brand" />
      </button>
    {/if}
  </div>
</form>
